import { QueryClient } from "@tanstack/vue-query"

export const defaultOptionsQueryClient = {
  queries: {
    staleTime: 1000 * 60 * 10,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  },
}

export const queryClient = new QueryClient({
  defaultOptions: defaultOptionsQueryClient,
})
